import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-reducao-carencia-medSenior',
  templateUrl: './reducao-carencia-medSenior.component.html',
  styleUrls: ['./reducao-carencia-medSenior.component.scss'],
})
export class ReducaoCarenciaMedSeniorComponent {
  @Input() titulo: string = 'GRUPO DE CARÊNCIAS';
}
